import ModalCompetitors, {
  MODAL_COMPETITORS_FROM_MENU,
} from "../Modal/ModalCompetitors";

const CompetitorScopeFlowModals = ({
  isCompetitorsModalOpen,
  onCloseCompetitorsModal,
  onCompetitorAdsSelected,
  initialPreviewLibraryID = null,
  onInitialPreviewLibraryIDConsumed = () => {},
}) => {
  return isCompetitorsModalOpen ? (
    <ModalCompetitors
      modalOpen={isCompetitorsModalOpen}
      onCloseModal={onCloseCompetitorsModal}
      from={MODAL_COMPETITORS_FROM_MENU}
      onCallbackSelectedItems={onCompetitorAdsSelected}
      initialPreviewLibraryID={initialPreviewLibraryID}
      onInitialPreviewLibraryIDConsumed={onInitialPreviewLibraryIDConsumed}
    />
  ) : null;
};

export default CompetitorScopeFlowModals;
